<template>
  <div></div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  props: {
    resultName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('document', ['fileObj']),
    ...mapState('system', ['routerStatusRedirect']),
  },
  methods: {
    ...mapActions('document', ['getDocuments']),
  },
  async created() {
    console.log(`status check ${this.resultName}`)
    if (!this.fileObj) {
      await this.getDocuments()
    }
    const { idCardVerificationIsDone } = this.me.kyc
    const { identification } = this.fileObj
    if (idCardVerificationIsDone === false || !identification) {
      const path = '/kyc/verify-id-card'
      if (this.$route.path !== path && this.routerStatusRedirect) {
        return await this.$router.replace(path)
      }
      return
    }
    // if (idCardImageVerified === false) {
    //   const path = '/apply/wait'
    //   if (this.$route.path !== path && this.routerStatusRedirect) {
    //     this.$router.replace(path)
    //   }
    //   return
    // }

    this.$emit('emitNext', {
      name: this.resultName,
      result: true,
    })
  },
}
</script>
